// src/pages/AuthRedirect.jsx (example)
import { useEffect } from 'react';
import { encrypt, isProfileComplete, role } from '../../helpers/functions';
import Loader from '../common/Loader';
import { getRequestAPI } from '../../helpers/service';
import { ROLE_NAME } from '../../helpers/constant';

function AuthRedirect() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const redirect_url = params.get('redirect_url');

  const handleRedireactionBasedOnRole = () => {
    // IF URL HAS REDIRECT URL YHEN REDIRECT IT
    if (redirect_url) {
      window.location.href = redirect_url;
      return;
    }

    switch (role()) {
      case ROLE_NAME.ADMIN:
        window.location.href = process.env.REACT_APP_API_BASE_URL;
        break;
      case ROLE_NAME.EXPERT:
        window.location.href = !isProfileComplete()
          ? `/expert/profile`
          : `/dashboard/expert/request`;
        break;
      default:
        window.location.href = '/dashboard/customer';
        break;
    }
  };

  const validateToken = async token => {
    try {
      const res = await getRequestAPI({
        url: 'validate-handoff',
        params: {
          token: token,
        },
      });

      if (res?.status !== 200) {
        throw new Error('Invalid token');
      }
      const userdata = res?.data?.data || [];

      //  if user email not validate then redirect to back
      if (userdata?.email_verified_at === null) {
        throw new Error('Email not verified');
      }

      localStorage.setItem('loggedInUser', encrypt(JSON.stringify(userdata)));

      localStorage.setItem('jwt', userdata?.token);

      localStorage.removeItem('jwtTmp', userdata?.token);

      handleRedireactionBasedOnRole();
      return;
    } catch (error) {
      window.location.href = process.env.REACT_APP_NEXT_PUBLIC_URL + '/?logout=true';
    }
  };
  
  useEffect(() => {
    if (!token) {
      if (localStorage.getItem('loggedInUser') && localStorage.getItem('jwt')) {
        handleRedireactionBasedOnRole();
        return;
      }
      window.location.href = process.env.REACT_APP_NEXT_PUBLIC_URL;
      return;
    }
    validateToken(token);
  }, [token]);

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader />
    </div>
  );
}

export default AuthRedirect;
